module.exports = __webpack_public_path__ + "img/KSC05077.0a1b8980.jpg";